import processingOperatorReducer from "./processingOperatorReducer";

const processingAgriculturalOperatorReducer = {
    processingOperator: processingOperatorReducer
}

export default processingAgriculturalOperatorReducer;